import React from "react";
import Padding from "../../shared/components/Padding";
import Spacer from "../../shared/components/Spacer";
import Close from "../../shared/components/Close";
import Seperator from "../../shared/components/Seperator";
import { motion} from "framer-motion";

function Modal({ headerText, size, modal, paddingX, paddingY, animationType = "normal", duration = "0.5"}) {

    return (
        <div className={modal.open ? "openModal modal" : "modal"} 
            style={{ zIndex: 10000 ,
            ...(animationType === "normal"
            ? {
                animation: `modal-bg-show ${duration}s`,
                WebkitAnimation: `modal-bg-show ${duration}s`,
                }
            : {})}}
        >
            {modal.open ? (
                <motion.div style={{width: size, margin: 'auto', backgroundColor: "white", borderRadius: "20px"}}
                    {...(animationType === "bottomTop"
                        ? {
                            initial: { opacity: 0, y: 50, scale: 0.95 },
                            animate: {
                                opacity: 1,
                                y: 0,
                                scale: 1,
                                transition: { duration: Number(duration), ease: "easeOut" }
                            },
                            exit: {
                                opacity: 0,
                                y: 50,
                                scale: 0.95,
                                transition: { duration: 0.2 }
                            }
                        }
                        : {}
                    )}
                >
                    <Padding paddingX={20} paddingY={20}>
                        <div style={{backgroundColor: "white", fontSize: "18px", fontWeight: "bold", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            {modal.headerText ? modal.headerText : headerText}
                            <Close size="md" onClick={modal.close} />
                        </div>
                        <Spacer direction="vertical" size={20} />
                        {modal.main}
                    </Padding>
                </motion.div>
            ) : null}
        </div>
    );
}

export default Modal;
